class CollectionInfiniteScroll {
  constructor() {
    this.grid = document.querySelector('#CollectionMosaicGrid');
    this.trigger = document.querySelector('#InfiniteScrollTrigger');

    if (!this.grid || !this.trigger) return;

    this.isLoading = false;
    this.sectionId = this.trigger.dataset.sectionId;
    this.nextUrl = this.trigger.dataset.nextUrl;

    this.initObserver();
  }

  initObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (entry.isIntersecting && !this.isLoading && this.nextUrl) {
          this.loadNextPage();
        }
      },
      {
        rootMargin: '600px 0px'
      }
    );

    this.observer.observe(this.trigger);
  }

  async loadNextPage() {
    this.isLoading = true;

    try {
      const url = new URL(this.nextUrl, window.location.origin);
      url.searchParams.set('section_id', this.sectionId);

      const response = await fetch(url.toString());

      if (!response.ok) {
        throw new Error('Failed to load next collection page');
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('#CollectionMosaicGrid');
      const newTrigger = doc.querySelector('#InfiniteScrollTrigger');

      if (newGrid) {
        const newProductCards = newGrid.querySelectorAll('.collection-product-card, .collection-promo');

        newProductCards.forEach((item) => {
          this.grid.appendChild(item);
        });
      }

      if (newTrigger && newTrigger.dataset.nextUrl) {
        this.nextUrl = newTrigger.dataset.nextUrl;
        this.trigger.dataset.nextUrl = this.nextUrl;
        this.isLoading = false;
      } else {
        this.nextUrl = null;
        this.trigger.remove();

        if (this.observer) {
          this.observer.disconnect();
        }
      }
    } catch (error) {
      console.error('Infinite scroll error:', error);
      this.isLoading = false;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionInfiniteScroll();
});